const GEO_CACHE_PREFIX = "geoJson_cache_";
const DIVISION_GEO_CACHE_PREFIX = "divisionGeoJson_cache_";

/**
 * Drops leftover GIS dumps from localStorage. Auth stays in sessionStorage.
 */
export const pruneStaleStorage = () => {
  try {
    const keysToRemove = [];

    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;

      if (
        key.startsWith(GEO_CACHE_PREFIX) ||
        key.startsWith(DIVISION_GEO_CACHE_PREFIX)
      ) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));

    const tabs = JSON.parse(localStorage.getItem("appTabs") || "[]");
    if (Array.isArray(tabs) && tabs.length > 10) {
      localStorage.setItem("appTabs", JSON.stringify(tabs.slice(-5)));
    }
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};
